import { Organization } from "./model/Organization";
import { OrganizationService } from "./services/OrganizationService";
import { LanguageDataService } from "./services/LanguageDataService";
import { CountryDataService } from "./services/CountryDataService";
import { LicenseTypeService } from "./services/LicenseTypeService";
import { AgbService } from "./services/AgbService";
import * as i0 from "@angular/core";
import * as i1 from "./services/OrganizationService";
import * as i2 from "./services/LanguageDataService";
import * as i3 from "./services/CountryDataService";
import * as i4 from "./services/LicenseTypeService";
import * as i5 from "./services/AgbService";
var AppController = /** @class */ (function () {
    function AppController(organizationService, languageDataService, countryDataService, licenseTypeService, agbService) {
        var _this = this;
        this._organization = new Organization();
        this._availableLanguages = [];
        this._availableCountries = [];
        this._availableLicenseTypes = [];
        this._agbText = "loading...";
        this._licenseRequestSubmitted = false;
        this._organizationService = organizationService;
        var languagesPromise = languageDataService.getLanguages();
        var countriesPromise = countryDataService.getCountries();
        var licenseTypesPromise = licenseTypeService.loadLicenseTypes();
        var agbTextPromise = agbService.loadAgbText();
        var passedOrganizationId = (window.location.hash ? window.location.hash.substring(1) : null);
        var organizationPromise = (passedOrganizationId ? organizationService.loadOrganization(passedOrganizationId) : Promise.resolve(null));
        Promise.all([languagesPromise, countriesPromise, licenseTypesPromise, agbTextPromise, organizationPromise])
            .then(function (_a) {
            var languages = _a[0], countries = _a[1], licenseTypes = _a[2], agbText = _a[3], organization = _a[4];
            _this._availableLanguages = languages;
            _this._availableCountries = countries;
            _this._availableLicenseTypes = licenseTypes;
            _this._agbText = agbText;
            if (organization) {
                Object.assign(_this._organization, organization);
                _this._currentPage = (_this._organization.newLicenseOrderDate ? "LicenseAlreadyOrderedPage" : "LicensePage");
            }
            else if (passedOrganizationId) {
                _this._currentPage = "OrganizationNotFoundPage";
            }
            else {
                _this._currentPage = "StartPage";
            }
            _this._organization.selectInitialNewLicenseType(licenseTypes);
        })
            .catch(function (error) { return _this.handleServiceCallFailure(error); });
    }
    Object.defineProperty(AppController.prototype, "organization", {
        get: function () {
            return this._organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "availableLanguages", {
        get: function () {
            return this._availableLanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "availableCountries", {
        get: function () {
            return this._availableCountries;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "availableLicenseTypes", {
        get: function () {
            return this._availableLicenseTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "agbText", {
        get: function () {
            return this._agbText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "licenseRequestSubmitted", {
        get: function () {
            return this._licenseRequestSubmitted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppController.prototype, "latestErrorMessage", {
        get: function () {
            return this._latestErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    AppController.prototype.isVisible = function (page) {
        return page === this._currentPage;
    };
    AppController.prototype.next = function (form) {
        if (form && !form.valid) {
            Object.values(form.controls).forEach(function (c) { return c.markAsTouched(); }); // highlight invalid fields
            return;
        }
        switch (this._currentPage) {
            case "StartPage":
                this._currentPage = "ContactAddressPage";
                break;
            case "ContactAddressPage":
                if (this._organization.isSeparateBillingAddress) {
                    this._organization.initBillingAddressIfNecessary();
                    this._currentPage = "BillingAddressPage";
                }
                else {
                    this._organization.copyContactAddressToBillingAddress();
                    this._currentPage = "LicensePage";
                }
                break;
            case "BillingAddressPage":
                this._currentPage = "LicensePage";
                break;
            case "LicensePage":
                this._currentPage = "AgbPage";
                break;
            case "AgbPage":
                this._currentPage = "ReviewPage";
                break;
        }
    };
    AppController.prototype.previous = function () {
        switch (this._currentPage) {
            case "ServerErrorPage":
            case "UserErrorPage":
                this._currentPage = "ReviewPage";
                break;
            case "ReviewPage":
                this._currentPage = "AgbPage";
                break;
            case "AgbPage":
                this._currentPage = "LicensePage";
                break;
            case "LicensePage":
                this._currentPage = (this._organization.isSeparateBillingAddress ? "BillingAddressPage" : "ContactAddressPage");
                break;
            case "BillingAddressPage":
                this._currentPage = "ContactAddressPage";
                break;
        }
    };
    AppController.prototype.submitLicenseRequest = function () {
        var _this = this;
        if (!this._licenseRequestSubmitted) {
            this._licenseRequestSubmitted = true;
            this._organizationService.submitLicenseRequest(this.organization)
                .then(function () { return _this._currentPage = "SuccessPage"; })
                .catch(function (error) {
                _this.handleServiceCallFailure(error);
                _this._licenseRequestSubmitted = false;
            });
        }
    };
    AppController.prototype.handleServiceCallFailure = function (errorResponse) {
        var errorInfo = errorResponse.error || {};
        console.error("Server call failed: status = " + errorResponse.status + " (" + errorResponse.statusText + "), error info = " + JSON.stringify(errorInfo));
        this._latestErrorMessage = (errorInfo.message || errorInfo.name || "Die Verbindung zum Server ist fehlgeschlagen (HTTP Status " + errorResponse.status + ")");
        this._currentPage = (errorInfo.isUserError ? "UserErrorPage" : "ServerErrorPage");
    };
    AppController.ngInjectableDef = i0.defineInjectable({ factory: function AppController_Factory() { return new AppController(i0.inject(i1.OrganizationService), i0.inject(i2.LanguageDataService), i0.inject(i3.CountryDataService), i0.inject(i4.LicenseTypeService), i0.inject(i5.AgbService)); }, token: AppController, providedIn: "root" });
    return AppController;
}());
export { AppController };
